export const UNDEFINED_LOCATION = 'Nowhere!'

export const DEFAULT_WISH_IMAGE = '/empty_wish.png'
